import usePrevious from 'hooks/useGetPreviousValue';

// It's predicate hook that tells us variable contains value equal value on previous render or not.
function useIsEqualPreviousValue(val, defaultVal = null) {
  const prevVal = usePrevious(val, defaultVal);
  return JSON.stringify(prevVal) === JSON.stringify(val);
}

export default useIsEqualPreviousValue;
